import { render, staticRenderFns } from "./MatrixContainer.vue?vue&type=template&id=3afca2c3&scoped=true"
import script from "./MatrixContainer.vue?vue&type=script&lang=ts"
export * from "./MatrixContainer.vue?vue&type=script&lang=ts"
import style0 from "./MatrixContainer.vue?vue&type=style&index=0&id=3afca2c3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afca2c3",
  null
  
)

export default component.exports